import React from 'react';
import Container from 'Nori/Container';
import Image from 'Nori/Image';
import styles from 'Custom/PocketCost/index.module.scss';

import ZERO_IMAGE from 'Images/misc/zero-price.png';
import MARBLE_BG from 'Images/misc/cost-banner.png';

const PocketCost = ({ className = '', children, ...props }) => (
  <div className={`${styles.pocketCost} ${className}`} {...props} style={{ backgroundImage: `url(${MARBLE_BG.src})` }}>
    <Container size="md" className={styles.pocketContainer}>
      <h2>98% of patient claims for NEXPLANON had</h2>
      <Image src={ZERO_IMAGE} />
      <p className={styles.outOfPocket}>out-of-pocket costs</p>
      <h2>
        in an analysis of representative commercial claims data<sup>‡</sup>
      </h2>
    </Container>
  </div>
);

export default PocketCost;
